import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/contact/components/AIChatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/contact/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/contact/components/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/ui/AppIcon.tsx");
